import { Link, useTrackCampaign } from '@packages/shared';
import { useRef } from 'react';
import type { LinkByTextType } from './types';
import { buildLinkWithArguments } from '../../utils';
import { Icon } from '../Icon/Icon';
import { registerComponents } from '../ComponentRecognizer/componentRegistry';
import { ComponentTypes } from '../../../interfaces';

/**
 * LinkByText component displays link with Arguments and an optional Icon with a direction
 * */
export const LinkByText = ({ data }: { data: LinkByTextType }) => {
  const { field_link: link, field_direction: direction, field_text: text, field_icon: icon } = data;
  const finalLink = buildLinkWithArguments(link, data);
  const linkRef = useRef<HTMLAnchorElement>(null);
  const { trackClick } = useTrackCampaign(data, linkRef, finalLink);
  return (
    <Link
      ref={linkRef}
      href={finalLink}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        color: 'text.dark',
        textDecorationColor: (theme) => theme.palette.text.dark,
        '& svg': {
          height: (theme) => theme.spacing(2),
          width: 'auto',
          ...(direction === 'left' && {
            order: '-1',
          }),
        },
      }}
      onClick={() => trackClick()}
    >
      <span>{text}</span>
      {icon && <Icon type={icon} />}
    </Link>
  );
};

// Needed to run this component in Storybook and Jest tests. Register the component in a global componentRegistry object
registerComponents({ [ComponentTypes.LinkByText]: LinkByText });
